"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.smileRatingSchema = exports.default = void 0;
var SmileRating_1 = require("./SmileRating");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(SmileRating_1).default; } });
Object.defineProperty(exports, "smileRatingSchema", { enumerable: true, get: function () { return SmileRating_1.smileRatingSchema; } });
//# sourceMappingURL=index.js.map